'use client';

import { datadogRum, type RumInitConfiguration } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { fetchDatadogUserData } from '../../actions/fetchUserDataAction';

interface DatadogInitProps {
    config: Omit<RumInitConfiguration, 'defaultPrivacyLevel'> & { defaultPrivacyLevel: string };
    enabled?: string | undefined;
}

export default function DatadogInit({ config, enabled }: DatadogInitProps): null {
    useEffect(() => {
        if (enabled === 'true' && !datadogRum.getInternalContext()) {
            datadogRum.init(config as RumInitConfiguration);
            void fetchDatadogUserData().then((userData) => {
                // Apply user data to Datadog RUM.
                if (userData) {
                    datadogRum.setUser({
                        id: userData.userId?.toString(),
                        isLoggedIn: userData.isLoggedIn,
                    });
                }
            });
        }
    }, [config, enabled]);

    return null;
}
